import { useCreateElplanMutation, useUpdateElplanMutation } from 'api/elplan/elplan.api'
import { useState } from 'react'
import type { ElplanDraft, ElplanSaveTarget } from './ElplanEditor.types'
import { serializeElplanDraft } from './save.serializer'

type ElplanEditorSaveInputs = {
  target: ElplanSaveTarget
  refetchPlan: () => Promise<unknown>
  onSaved: () => void
}

type ElplanEditorSave = {
  save: (draft: ElplanDraft) => Promise<void>
  isPending: boolean
}

export function useElplanEditorSave({ target, refetchPlan, onSaved }: ElplanEditorSaveInputs): ElplanEditorSave {
  const { mutateAsync: createElplan } = useCreateElplanMutation()
  const { mutateAsync: updateElplan } = useUpdateElplanMutation()
  const [isPending, setIsPending] = useState(false)

  function writeElplan(draft: ElplanDraft): Promise<unknown> {
    return target.kind === 'create'
      ? createElplan(serializeElplanDraft(draft, target))
      : updateElplan(serializeElplanDraft(draft, target))
  }

  async function save(draft: ElplanDraft): Promise<void> {
    const written = writeElplan(draft)
    setIsPending(true)
    try {
      await written
    } catch {
      setIsPending(false)
      return
    }
    await refetchPlan()
    onSaved()
  }

  return { save, isPending }
}
